import { Vessel } from '@navstation-portal/vessels/data-model/vessel';
import { SelectItemGroup } from 'primeng/api';

export function buildGroupedVessels(vessels: Vessel[] | null): SelectItemGroup<Vessel>[] {
  return buildGroupedVessels();

  function buildGroupedVessels() {
    if (!vessels?.length) return [];

    const groupedByClass = vessels.reduce(groupByClass, {});
    return Object.keys(groupedByClass)
      .sort()
      .map((key) => {
        return {
          label: key,
          value: key,
          items: groupedByClass[key].sort(sortByName).map((vessel) => {
            return {
              label: vessel.name,
              value: vessel,
            };
          }),
        };
      });
  }
}

const groupByClass = (acc: Record<string, Vessel[]>, v: Vessel) => {
  const clazz = v.class || 'Unclassified';
  const group = acc[clazz];
  if (group) {
    group.push(v);
  } else {
    acc[clazz] = [v];
  }
  return acc;
};

const sortByName = (a: Vessel, b: Vessel): number => {
  return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
};
